import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, Calendar, Users, Plane } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import api from "../lib/api";
import { formatINR } from "../mock";
import Footer from "../components/Footer";
import { Button } from "../components/ui/button";

export default function MyTrips() {
  const { user } = useAuth();
  const [bookings, setBookings] = useState([]);

  useEffect(() => {
    if (user) api.get("/bookings/me").then((res) => setBookings(res.data)).catch(() => {});
  }, [user]);

  if (!user) {
    return (
      <div className="min-h-screen grid place-items-center hero-dark px-5">
        <div className="bg-white rounded-2xl p-8 text-center">
          <p className="text-slate-600">Please log in to view your trips.</p>
          <Link to="/login"><Button className="mt-4 bg-coral-600 text-white">Log in</Button></Link>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white min-h-screen">
      <section className="hero-dark pt-28 pb-14">
        <div className="max-w-7xl mx-auto px-5">
          <h1 className="text-4xl font-bold text-white">My Trips</h1>
          <p className="mt-2 text-slate-300">Hi {(user.name || user.email || "there").split(" ")[0]}, here are your bookings.</p>
        </div>
      </section>
      <section className="max-w-5xl mx-auto px-5 py-12">
        {bookings.length === 0 ? (
          <div className="text-center py-16">
            <Plane className="w-12 h-12 text-slate-300 mx-auto" />
            <p className="mt-4 text-slate-500">You haven’t booked any trips yet.</p>
            <Link to="/tours"><Button className="mt-4 bg-coral-600 text-white">Explore Tours</Button></Link>
          </div>
        ) : (
          <div className="space-y-4">
            {bookings.map((b) => (
              <div key={b.id} className="bg-white rounded-2xl border border-slate-200 p-5 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                <div>
                  <div className="flex items-center gap-2">
                    <span className="text-xs font-mono text-slate-400">#{b.id}</span>
                    <span className="text-[11px] font-bold px-2 py-0.5 rounded bg-orange-50 text-orange-700">{b.status}</span>
                  </div>
                  <h3 className="mt-1 font-display font-semibold text-slate-900">{b.tourTitle}</h3>
                  <div className="mt-2 flex flex-wrap gap-4 text-sm text-slate-500">
                    <span className="flex items-center gap-1"><MapPin className="w-4 h-4" /> {b.tourLocation}</span>
                    <span className="flex items-center gap-1"><Calendar className="w-4 h-4" /> {b.date}</span>
                    <span className="flex items-center gap-1"><Users className="w-4 h-4" /> {b.travelers} traveler(s)</span>
                  </div>
                </div>
                <div className="text-right">
                  <p className="font-display font-bold text-xl text-slate-900">{formatINR(b.total)}</p>
                  <Button size="sm" className="mt-2 bg-coral-600 text-white" disabled>Pay with Razorpay</Button>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
